import { Component, OnInit,Input } from '@angular/core';
import { HomepageService } from '../../../services/homepage.service';

@Component({
  selector: 'app-links',
  templateUrl: './links.component.html',
  styleUrls: ['./links.component.css']
})
export class LinksComponent implements OnInit {

 constructor( private homepageService: HomepageService ) {}
 widgetsSetting: any = [];
 @Input() buId: number;
  ngOnInit() {
  		this.getwidgetsSetting();
  }

  	getwidgetsSetting() {
      let getwidgetsSettingDataSave =  this.homepageService.getwidgetsSettingDataSave();
      getwidgetsSettingDataSave.data.forEach(evt => {
            if(evt.code == 'LK' && this.buId  == evt.id){
              this.widgetsSetting = evt.settings;              
             }
            
          });     
    }

}
